import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { generateResumeShareLink } from "../../api/resume";
import { log } from "../../utils/log_utils";
import { removeUserCache } from "../../utils/client_storage_utils";
import { useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";


const ShareOptions = ({ shareOptions, shareConfig, setShareConfig, onCancel, handleGenerateLink, loading }) => {

    // Handle option change
    const handleOptionChange = (key, value) => {
        setShareConfig(prev => ({
            ...prev,
            [key]: value
        }));
    };



    return (<div className="">
        {shareOptions.length > 0 && (
            <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Share Options
                </label>
                <div className="space-y-3">
                    {shareOptions.map((option) => (
                        <div key={option.key} className="flex items-center justify-between">
                            <span className="text-sm text-gray-700 flex-shrink-0">
                                {option.label}
                            </span>
                            <div className="ml-3">
                                {option.type === 'checkbox' ? (
                                    <input
                                        type="checkbox"
                                        checked={shareConfig[option.key] || false}
                                        onChange={(e) => handleOptionChange(option.key, e.target.checked)}
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                    />
                                ) : option.type === 'select' ? (
                                    <select
                                        value={shareConfig[option.key] || option.defaultValue}
                                        onChange={(e) => handleOptionChange(option.key, e.target.value)}
                                        className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white min-w-[100px]"
                                    >
                                        {option.options.map((optionValue) => (
                                            <option key={optionValue} value={optionValue}>
                                                {optionValue.charAt(0).toUpperCase() + optionValue.slice(1)}
                                            </option>
                                        ))}
                                    </select>
                                ) : null}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )}

        {
            loading ? 
                (<div className="flex items-center justify-center">
                    <BeatLoader size={6} color="#4f46e5" />
                  </div>)
            :
            (<div className="flex justify-center space-x-3">
                <button
                    onClick={onCancel}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    Cancel
                </button>
                <button
                    onClick={handleGenerateLink}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Generate Link
                </button>
            </div>)

        }
    </div>)
}


const ShareURLSection = ({ shareUrl, setShareUrl }) => {
    
    const [copied, setCopied] = useState(false);

    // Copy to clipboard function
    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 5000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return ((
        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                Share URL
            </label>
            <div className="flex">
                <input
                    type="text"
                    value={shareUrl}
                    readOnly
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                />
                <button
                    onClick={() => copyToClipboard(shareUrl)}
                    className="px-3 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                    {copied ? (
                        <Check className="h-4 w-4" />
                    ) : (
                        <Copy className="h-4 w-4" />
                    )}
                </button>
            </div>
            {copied && (
                <p className="text-xs text-green-600 mt-1">Copied to clipboard!</p>
            )}
        </div>
    ))
}


const SharePopup = ({ 
    title,
    onCancel,
    resumeId
}) => {

    const navigate = useNavigate()

    const shareOptions = [
        {
            key: "visibility",
            label: "Who can view",
            defaultValue: "public",
            type: "select",
            options: ["public", "protected"]
        },
        {
            key: "showAnalysis",
            label: "Show analytics",
            defaultValue: true,
            type: "checkbox"
        },
        {
            key: "showComments", 
            label: "Show coments to viewers",
            defaultValue: true,
            type: "checkbox"
        },
        {
            key: "allowComments", 
            label: "Allow viewers to comment",
            defaultValue: true,
            type: "checkbox"
        },
        // {
        //     key: "allowDownload",
        //     label: "Allow Download",
        //     defaultValue: false,
        //     type: "checkbox"
        // }
    ];

    
    const [shareConfig, setShareConfig] = useState(() => {
        return shareOptions.reduce( (acc, curr)=> ({...acc, [curr.key]: curr.defaultValue }),{})
    });

    const [shareUrl, setShareUrl] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)



    

    
    // Handle generate link btn click
    const handleGenerateLink = async (e) => {
        e.preventDefault()
        try{
            setLoading(true)
            const { success, resp } = await generateResumeShareLink(resumeId, shareConfig)
            log('response', resp, 'handleGenerateLink')
            if(success){
                const sharingLink = resp.shareLink
                if(sharingLink){
                    setShareUrl(sharingLink)
                }
            }
            else{
                if(resp?.toLowerCase() === "invalid user identity"){
                    removeUserCache()
                    navigate("/")
                }
                setError(resp)
            }

        }catch(error){
            setError(error?.message || "something went wrong :(")
        } finally{
            setLoading(false)
        }
    };

    const renderContent = () => {

        if(shareUrl) return  <ShareURLSection shareUrl={shareUrl} setShareUrl={setShareUrl} />

        if(!shareUrl) return <ShareOptions loading={loading} shareConfig={shareConfig} setShareConfig={setShareConfig} shareOptions={shareOptions} handleGenerateLink={handleGenerateLink} />
    }

    return (
        <div>
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
                <Share2 className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2 text-center">
                {title}
            </h3>
            {renderContent()}
            {error && <p className="text-red-500 font-semibold mb-8">{"*" + error}</p>}
            
        </div>
    );
};

export default SharePopup; 